import { Game } from "./game"

export const speedMap: Record<Game, number[]> = {
  [Game.MK8]: [150],
  [Game.MK8DX]: [150, 200],
}
